import { Anchor } from '@radix-ui/react-popover';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Anchor>;
export const PopoverAnchor = (props: Props) => {
    return <Anchor data-testid="popover-anchor" {...props} />;
};
